import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertContact, ContactVerification, AlertEnrollmentContactTableData, AlertEnrollmentContact } from 'app/shared/models/Alerts';
import { AnnouncementsService } from 'app/layout/announcements/announcements.service';
import { EvoToastr } from 'app/shared/services/EvoToastr.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EvoPatternValidator } from 'app/shared/validators/evo-pattern-validator.directive';
import { FormatService } from 'app/shared/services/format.service';
import { FormsValidationService } from 'app/shared/services/formsValidation.service';
import { SubscriptionLike as ISubscription, Observable, forkJoin } from 'rxjs';
import { BindingContext } from 'app/shared/models/BindingContext';

@Component({
    selector: 'delivery-selector-modal',
    styleUrls: ['./delivery-selector.component.scss'],
    templateUrl: 'delivery-selector.component.html',
})
export class DeliverySelectorComponent {
    bindingContext: BindingContext = new BindingContext();
    public contactData: AlertEnrollmentContactTableData;
    public title: string = "Manage Delivery";

    constructor(public activeModal: NgbActiveModal,
        private annSvc: AnnouncementsService,
        private toastSvc: EvoToastr, ) {
    }

    ngOnInit() {
        console.log("contact data in modal: ", this.contactData);
    }

    ngOnDestroy() {

    }

    onModalSubmit() {
        //This probably won't do anything
        this.activeModal.close(true); //True refresh the data
    }

    toggleDefaultEnrollment(row: AlertEnrollmentContact) {
        if (row.AlertEnrollmentContactID) {
            this.bindingContext.beginGet();
            //delete
            row.DeliverEmail = false;
            row.DeliverSMS = false;
            this.annSvc.DeleteAlertEnrollmentContact(row.AlertEnrollmentContactID).subscribe(resp => {
                this.refreshData();
                this.bindingContext.endGet();
            }, err => {
                this.bindingContext.endGet();
                this.toastSvc.toastFailure('Error', 'Failed to unenroll, please try again or contact support if this problem persists.');
            });
        } else {
            this.updateEnrollment(row);
        }
    }

    /**
     * Refreshes the current contact list which is passed by reference
     */
    refreshData() {
        this.bindingContext.beginGet();
        this.annSvc.GetAlertEnrollmentContactList(this.contactData.AlertEnrollmentID).toPromise().then(resp => {
            this.contactData.Contacts = resp;
            this.bindingContext.endGet();
        }).catch(err => {
            this.toastSvc.toastFailure('Error', 'There was an error retrieving your data please try again.');
            this.bindingContext.endGet();
        });
    }

    updateEnrollment(row: AlertEnrollmentContact) {
        this.bindingContext.beginGet();
        if (row.AlertContactID !== null && (row.DeliverSMS === false && row.DeliverEmail === false)) {
            //this is a non-default
            this.annSvc.DeleteAlertEnrollmentContact(row.AlertEnrollmentContactID).subscribe(resp => {
                this.refreshData();
                this.bindingContext.endGet();
            }, err => {
                this.bindingContext.endGet();
                this.toastSvc.toastFailure('Error', 'Unable to update delivery options, please try again or contact support if this problem persists.');
            });
        } else {
            //This is the default or a regular contact with delivery of one type == true
            if (row.DeliverSMS === null) { row.DeliverSMS = false; }
            if (row.DeliverEmail === null) { row.DeliverEmail = false; }
            row.AlertEnrollmentID = this.contactData.AlertEnrollmentID;
            this.annSvc.UpdateAlertEnrollmentContact(row).then(resp => {
                this.bindingContext.endGet();
                this.refreshData();
            }).catch(err => {
                this.toastSvc.toastFailure('Error', 'Unable to update delivery options, please try again or contact support if this problem persists.');
                this.bindingContext.endGet();
            });
        }
    }
}
